/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

// 验证是否整数
export function isInteger(rule, value, callback) {
  if (!value && value !== 0) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(() => {
    if (!Number(value) && Number(value) !== 0) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[+]{0,1}(\d+)$/;
      const rsCheck = re.test(value);
      if (!rsCheck || Number(value) < 0) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 0);
}
//校验手机号
export function isMobileNumber(rule, value, callback) {
  if (!value) {
    return new Error("请输入电话号码");
  } else {
    const reg = /^1[0-9][0-9]\d{8}$/;
    const isPhone = reg.test(value);
    value = Number(value); //转换为数字
    if (typeof value === "number" && !isNaN(value)) {//判断是否为数字
      value = value.toString(); //转换成字符串
      if (value.length < 0 || value.length > 12 || !isPhone) { //判断是否为11位手机号
        callback(new Error("手机号码格式如:138xxxx8754"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请输入电话号码"));
    }
  }
};

// 金额验证
export function validatorPrice(rule, value, callback) {
  if (!value) return callback(new Error(''))
  if (!Number(value)) return callback(new Error('请输入数字值'))
  // let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})$/g; //小数限制0-2位
  let reg = /((^[1-9]\d*)|^0)(\.\d{0,6}){0,1}$/;
  if (!reg.test(value)) return callback(new Error('请输入正确价格'));
  callback();
};




// WEBPACK FOOTER //
// ./src/utils/validate.js